import { ESorting } from '../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { COMMUTE_TYPES_MAP } from '../interfaces/villages';

export interface ISortingKeys {
  [key: string]: ESorting;
}

export function getSortingKeys(): ISortingKeys {
  return {
    COMMUTE: ESorting.Commute,
    DEFAULT: ESorting.Default,
    HOUSE_AREA: ESorting.HouseArea,
    ID: ESorting.Id,
    LANDPLOT_AREA: ESorting.LandplotArea,
    PRICE: ESorting.Price,
    TERMINAL_DISTANCE: ESorting.TerminalDistance,
  };
}

interface IGetSortingNamesParams {
  regionHasRoads: boolean;
  regionHasStations: boolean;
  regionId?: number;
}

export interface ISortingNames {
  [key: string]: string | undefined;
}

export function getSortingNames({
  regionHasRoads,
  regionHasStations,
  regionId,
}: IGetSortingNamesParams): ISortingNames {
  const sortingKeys = getSortingKeys();

  const sortingNames = {
    [sortingKeys.DEFAULT]: 'По умолчанию',
    [sortingKeys.PRICE]: 'По цене (сначала дешевые)',
    [sortingKeys.HOUSE_AREA]: 'По площади дома',
    [sortingKeys.LANDPLOT_AREA]: 'По площади участка',
    [sortingKeys.ID]: 'По ID',
  };

  if (regionHasRoads) {
    sortingNames[sortingKeys.COMMUTE] = `По расстоянию до ${(regionId && COMMUTE_TYPES_MAP[regionId]) || 'центра'}`;
  }
  if (regionHasStations) {
    sortingNames[sortingKeys.TERMINAL_DISTANCE] = 'По расстоянию до вокзала';
  }

  return sortingNames;
}
